<template>
  <div @click="handleClick" class="btn --red">
    <i class="fas fa-trash-alt"></i>
  </div>
</template>

<script>
import { SnotifyPosition, SnotifyStyle } from 'vue-snotify';
import { mapState, mapActions } from 'vuex';
import { deleteBooking } from '../../../services/endpoints';

export default {
  props: {
    id: Number,
  },

  computed: {
    ...mapState({
      pin: state => state.auth.pin,
    }),
  },

  methods: {
    ...mapActions(['setSuccessMessage', 'setErrorMessage']),

    handleClick() {
      const doDelete = () => new Promise((resolve, reject) => {
        deleteBooking(this.id, this.pin).then(() => {
          this.setSuccessMessage('Deleted Booking');
          resolve();
        }).catch(() => {
          this.setErrorMessage('Could not delete booking.');
          reject();
        });
      });

      this.$snotify.confirm('Delete this booking?', 'Delete Booking', {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        position: SnotifyPosition.centerCenter,
        type: SnotifyStyle.warning,
        buttons: [
          {
            text: 'Delete',
            action: (toast) => {
              doDelete().then(() => {
                this.$emit('success');
                this.$snotify.remove(toast.id);
              });
            },
            bold: true,
          },
          { text: 'Cancel' },
        ],
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Booking/ActionButtons/Delete.vue